export default __webpack_public_path__ + "static/media/logo.4f38f009.png";